import { useCallback } from "react";
import { GroupsApi, ReportingMelcoMachineStatisticsModelsGroupListItem, useGroupsAPI } from "melco-shared-logic";

// export const useMachineGroupsWithAPIAction = () => {
//   const [getAllMachinesGroups] = useAPIAction(
//     GroupsApi,
//     async (api: GroupsApi) => {
//       const data = await api.statisticsGroupsSearch({
//         searchText: undefined,
//       });

//       return {
//         successMessages: [],
//         data,
//       };
//     },
//     {
//       translationPrefix: "",
//     }
//   );
//   useGroupsAPI<>
//   return useCallback(async () => {
//     try {
//       return await getAllMachinesGroups();
//     } catch (e) {
//       // error handling is already done in useAPIAction
//     }
//   }, [getAllMachinesGroups]);
// };

type MachinesData = {
  machineGroups: ReportingMelcoMachineStatisticsModelsGroupListItem[];
};

const initialValue = { machineGroups: [] };

export const useMachineGroupsWithAPIAction = () => {
  const handleRequest = useCallback(
    async (api: GroupsApi) => {
      const response = await api.statisticsGroupsSearch({
        searchText: undefined,
      });

      const machineGroups = response.list
      return {
        machineGroups
      }
    },
    []
  );

  return useGroupsAPI<MachinesData>({
    initialValue,
    handleRequest,
  });
}

